import React, { useEffect, useState } from 'react';
import Navbar from '../../components/userHomeNavBar/navBar';
import SideBar from '../../components/userHomeSideBar/sideBar';
import { useAuth } from "../../context/DBContext";
import LoadingOverlay from '@murasoftware/react-loading-overlay';
import { createCheckoutSession, createManagePortal, GetCustomClaimRole } from '../../api/stripe';
import { useNavigate } from 'react-router-dom';

const SubscriptionPage = () => {
    const { currentUser } = useAuth();
    const [loading, setLoading] = useState(false);
    const [subRole, setSubRole] = useState();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchUserRole = async () => {
            try {
                const userRole = await GetCustomClaimRole();
                setSubRole(userRole);
            } catch (error) {
                // console.error('Error fetching user role:', error);
            }
        };

        fetchUserRole();
    }, []);

    const handleManagePortal = async () => {
        setLoading(true);
        await createManagePortal();
        setLoading(false);
    };

    const handleBasicCheckoutSession = async () => {
        if (!currentUser) {
            navigate('/signup');
            return null;
        }
        setLoading(true);
        await createCheckoutSession(currentUser, "price_1Pdv5HAvZwPFUfRcpfZaDyFC");
        setLoading(false);
    };

    const handlePremiumCheckoutSession = async () => {
        if (!currentUser) {
            navigate('/signup');
            return null;
        }
        setLoading(true);
        await createCheckoutSession(currentUser, "price_1Pdv5UAvZwPFUfRcWBiLmORv");
        setLoading(false);
    };

    const handleEnterpriseCheckoutSession = async () => {
        if (!currentUser) {
            navigate('/signup');
            return null;
        }
        setLoading(true);
        await createCheckoutSession(currentUser, "price_1PiqJ9AvZwPFUfRc6p9wQrQO");
        setLoading(false);
    };

    return (
        <div>
            <LoadingOverlay
                active={loading}
                spinner
                text='Loading...'
            >
                <Navbar />
                <SideBar />
                <section className="content">
                    <div className="block-header">
                        <div className="row">
                            <div className="col-lg-7 col-md-6 col-sm-12">
                                <h2>Your plan is currently {subRole || 'basic'}</h2>
                            </div>
                            <div className="col-lg-5 col-md-6 col-sm-12">
                                <ul className="breadcrumb float-md-right">
                                    <li className="breadcrumb-item"><a href="index.html"><i className="zmdi zmdi-home" /> Compass</a></li>
                                    <li className="breadcrumb-item"><a href="javascript:void(0);">Pages</a></li>
                                    <li className="breadcrumb-item active">Subscription</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="container-fluid">
                        {subRole === 'inactive' ? (
                            <div className="row clearfix">
                                <div className="col-lg-12">
                                    <div className="pricing pricing-palden">
                                        <div className="pricing-item">
                                            <div className="pricing-deco l-slategray">
                                                <svg className="pricing-deco-img" enableBackground="new 0 0 300 100" height="100px" id="Layer_1" preserveAspectRatio="none" version="1.1" viewBox="0 0 300 100" width="300px" x="0px" xmlSpace="preserve" xmlnsXlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" y="0px">
                                                    <path className="deco-layer deco-layer--1" d="M30.913,43.944c0,0,42.911-34.464,87.51-14.191c77.31,35.14,113.304-1.952,146.638-4.729
                                                    c48.654-4.056,69.94,16.218,69.94,16.218v54.396H30.913V43.944z" fill="#FFFFFF" opacity="0.6" />
                                                    <path className="deco-layer deco-layer--2" d="M-35.667,44.628c0,0,42.91-34.463,87.51-14.191c77.31,35.141,113.304-1.952,146.639-4.729
                                                    c48.653-4.055,69.939,16.218,69.939,16.218v54.396H-35.667V44.628z" fill="#FFFFFF" opacity="0.6" />
                                                    <path className="deco-layer deco-layer--3" d="M43.415,98.342c0,0,48.283-68.927,109.133-68.927c65.886,0,97.983,67.914,97.983,67.914v3.716
                                                    H42.401L43.415,98.342z" fill="#FFFFFF" opacity="0.7" />
                                                    <path className="deco-layer deco-layer--4" d="M-34.667,62.998c0,0,56-45.667,120.316-27.839C167.484,57.842,197,41.332,232.286,30.428
                                                    c53.07-16.399,104.047,36.903,104.047,36.903l1.333,36.667l-372-2.954L-34.667,62.998z" fill="#FFFFFF" />
                                                </svg>
                                                <div className="pricing-price"><span className="pricing-currency">$</span>19
                                                    <span className="pricing-period">/ mo</span>
                                                </div>
                                                <h3 className="pricing-title">BASIC</h3>
                                            </div>
                                            <ul className="feature-list">
                                                <li>5GB Disk Space</li>
                                                <li>10 Domain Names</li>
                                                <li>5 E-Mail Address</li>
                                                <li>Fully Support</li>
                                            </ul>
                                            <button onClick={handleBasicCheckoutSession} className="pricing-action l-amber">Start Subscription</button>
                                        </div>
                                        <div className="pricing-item pricing__item--featured">
                                            <div className="pricing-deco l-blush">
                                                <svg className="pricing-deco-img" enableBackground="new 0 0 300 100" height="100px" id="Layer_1" preserveAspectRatio="none" version="1.1" viewBox="0 0 300 100" width="300px" x="0px" xmlSpace="preserve" xmlnsXlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" y="0px">
                                                    <path className="deco-layer deco-layer--1" d="M30.913,43.944c0,0,42.911-34.464,87.51-14.191c77.31,35.14,113.304-1.952,146.638-4.729
                                                    c48.654-4.056,69.94,16.218,69.94,16.218v54.396H30.913V43.944z" fill="#FFFFFF" opacity="0.6" />
                                                    <path className="deco-layer deco-layer--2" d="M-35.667,44.628c0,0,42.91-34.463,87.51-14.191c77.31,35.141,113.304-1.952,146.639-4.729
                                                    c48.653-4.055,69.939,16.218,69.939,16.218v54.396H-35.667V44.628z" fill="#FFFFFF" opacity="0.6" />
                                                    <path className="deco-layer--3" d="M43.415,98.342c0,0,48.283-68.927,109.133-68.927c65.886,0,97.983,67.914,97.983,67.914v3.716
                                                    H42.401L43.415,98.342z" fill="#FFFFFF" opacity="0.7" />
                                                    <path className="deco-layer deco-layer--4" d="M-34.667,62.998c0,0,56-45.667,120.316-27.839C167.484,57.842,197,41.332,232.286,30.428
                                                    c53.07-16.399,104.047,36.903,104.047,36.903l1.333,36.667l-372-2.954L-34.667,62.998z" fill="#FFFFFF" />
                                                </svg>
                                                <div className="pricing-price"><span className="pricing-currency">$</span>33
                                                    <span className="pricing-period">/ mo</span>
                                                </div>
                                                <h3 className="pricing-title">PROFESSIONAL</h3>
                                            </div>
                                            <ul className="feature-list">
                                                <li>10GB Disk Space</li>
                                                <li>20 Domain Names</li>
                                                <li>10 E-Mail Address</li>
                                                <li>Fully Support</li>
                                            </ul>
                                            <button onClick={handlePremiumCheckoutSession} className="pricing-action l-slategray">Start Subscription</button>
                                        </div>
                                        <div className="pricing-item">
                                            <div className="pricing-deco l-slategray">
                                                <svg className="pricing-deco-img" enableBackground="new 0 0 300 100" height="100px" id="Layer_1" preserveAspectRatio="none" version="1.1" viewBox="0 0 300 100" width="300px" x="0px" xmlSpace="preserve" xmlnsXlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" y="0px">
                                                    <path className="deco-layer deco-layer--1" d="M30.913,43.944c0,0,42.911-34.464,87.51-14.191c77.31,35.14,113.304-1.952,146.638-4.729
                                                    c48.654-4.056,69.94,16.218,69.94,16.218v54.396H30.913V43.944z" fill="#FFFFFF" opacity="0.6" />
                                                    <path className="deco-layer deco-layer--2" d="M-35.667,44.628c0,0,42.91-34.463,87.51-14.191c77.31,35.141,113.304-1.952,146.639-4.729
                                                    c48.653-4.055,69.939,16.218,69.939,16.218v54.396H-35.667V44.628z" fill="#FFFFFF" opacity="0.6" />
                                                    <path className="deco-layer deco-layer--3" d="M43.415,98.342c0,0,48.283-68.927,109.133-68.927c65.886,0,97.983,67.914,97.983,67.914v3.716
                                                    H42.401L43.415,98.342z" fill="#FFFFFF" opacity="0.7" />
                                                    <path className="deco-layer deco-layer--4" d="M-34.667,62.998c0,0,56-45.667,120.316-27.839C167.484,57.842,197,41.332,232.286,30.428
                                                    c53.07-16.399,104.047,36.903,104.047,36.903l1.333,36.667l-372-2.954L-34.667,62.998z" fill="#FFFFFF" />
                                                </svg>
                                                <div className="pricing-price"><span className="pricing-currency">$</span>99
                                                    <span className="pricing-period">/ mo</span>
                                                </div>
                                                <h3 className="pricing-title">ENTERPRISE</h3>
                                            </div>
                                            <ul className="feature-list">
                                                <li>50GB Disk Space</li>
                                                <li>50 Domain Names</li>
                                                <li>20 E-Mail Address</li>
                                                <li>Fully Support</li>
                                            </ul>
                                            <button onClick={handleEnterpriseCheckoutSession} className="pricing-action l-amber">Start Subscription</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="row clearfix">
                                <div className="col-lg-12">
                                    <button onClick={handleManagePortal} className="btn l-amber">Manage Subscription</button>
                                </div>
                            </div>
                        )}
                    </div>
                </section>
            </LoadingOverlay>
        </div>
    );
};

export default SubscriptionPage;
